import React, { useState, useRef } from 'react';
import { FaEnvelope, FaGithub, FaLinkedin, FaCheck } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import portfolioData from '../data/portfolioData';

const ContactSection: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formRef.current) return;

    setIsSending(true);
    setError('');

    try {
      // EmailJS: Replace these IDs with your own from emailjs.com
      await emailjs.sendForm(
        'YOUR_SERVICE_ID',    // ← Replace with your EmailJS service ID
        'YOUR_TEMPLATE_ID',   // ← Replace with your EmailJS template ID
        formRef.current,
        'YOUR_PUBLIC_KEY'     // ← Replace with your EmailJS public key
      );
      setIsSent(true);
      formRef.current.reset();
    } catch (err) {
      setError('Erreur lors de l\'envoi. Réessayez ou contactez-moi par email.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <h2 className="section__title">Contact</h2>
        <p className="section__subtitle">
          Un projet en tête ? Discutons-en.
        </p>
        <div className="section__divider" />

        <div className="contact__inner">
          {/* Info side */}
          <div className="contact__info">
            <h3 className="contact__info-title">Travaillons ensemble</h3>
            <p className="contact__info-desc">
              Disponible pour une alternance, un stage ou une mission freelance. 
              Envoyez-moi un message et je vous répondrai sous 24h.
            </p>

            <div className="contact__links">
              <a
                href={`mailto:${portfolioData.contact.email}`}
                className="contact__link"
              >
                <FaEnvelope />
                <span>{portfolioData.contact.email}</span>
              </a>
              <a
                href={portfolioData.contact.github}
                target="_blank"
                rel="noopener noreferrer"
                className="contact__link"
              >
                <FaGithub />
                <span>GitHub</span>
              </a>
              <a
                href={portfolioData.contact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="contact__link"
              >
                <FaLinkedin />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>

          {/* Form side */}
          <form ref={formRef} onSubmit={handleSubmit} className="contact__form">
            <div className="contact__field">
              <label htmlFor="contact-name">Nom</label>
              <input
                type="text"
                id="contact-name"
                name="from_name"
                placeholder="Votre nom"
                required
              />
            </div>

            <div className="contact__field">
              <label htmlFor="contact-email">Email</label>
              <input
                type="email"
                id="contact-email"
                name="from_email"
                placeholder="votre@email.com"
                required
              />
            </div>

            <div className="contact__field">
              <label htmlFor="contact-message">Message</label>
              <textarea
                id="contact-message"
                name="message"
                placeholder="Décrivez votre projet ou votre besoin..."
                required
              />
            </div>

            {error && (
              <p style={{ color: '#EF4444', fontSize: '0.9rem' }}>{error}</p>
            )}

            {isSent ? (
              <div className="contact__success">
                <FaCheck />
                Message envoyé avec succès ! Je vous répondrai rapidement.
              </div>
            ) : (
              <button
                type="submit"
                className="btn btn--primary"
                disabled={isSending}
                style={{ opacity: isSending ? 0.7 : 1 }}
              >
                {isSending ? 'Envoi en cours...' : 'Envoyer le message'}
              </button>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
